import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
import { defaultSmDate } from '../utils/formatter';

export interface Maschinenkunde {
    kNr: number;
    lNr: number;
    type: string;
    baujahr: number;
    hersteller: string;
    geraeteNr: string;
    artikelNr: string;
    rNr: string;
    bem: string;
    lDat: string;
    datAusgesch: string;
    mtNr: number;
    archiv: boolean;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export const defaultMaschinenkunde: Maschinenkunde = {
    kNr: 0,
    lNr: 0,
    type: '',
    baujahr: 0,
    hersteller: '',
    geraeteNr: '',
    artikelNr: '',
    rNr: '',
    bem: '',
    mtNr: 0,
    archiv: false,
    lDat: defaultSmDate,
    datAusgesch: defaultSmDate,
};

export interface MaschinenkundeFilter {
    kNr?: number;
    lNr?: number;
    includeArchiv?: boolean;
    maxRows?: number;
}

export function useMaschinenkundeList(
    filter: MaschinenkundeFilter,
    apiOptions?: UseApiOptions<Maschinenkunde[]>,
): QueryResult<Maschinenkunde[]> {
    return useApi<Maschinenkunde[]>(Controller.maschinenkunde + '/list', { filter }, apiOptions);
}

export async function addMaschinenkunde(maschinenkunde: Maschinenkunde): Promise<void> {
    return callApi<void>(Controller.maschinenkunde + '/add', { maschinenkunde });
}

export async function updateMaschinenkunde(maschinenkunde: Maschinenkunde): Promise<void> {
    return callApi<void>(Controller.maschinenkunde + '/update', { maschinenkunde });
}
